import getI18nProps from '@/utils/i18/getI18nProps';
import { styled } from '@mui/material/styles';
import DiceGame from '@/components/features/casino/dice';
import { Box } from '@mui/material';
import CatchError from '@/components/system/CacthError';

/* eslint-disable-next-line */
export interface DiceCrashProps {}

const StyledDice = styled(Box)``;

// export const runtime = 'experimental-edge';
export function Dice(props: DiceCrashProps) {
  return <StyledDice>{<DiceGame />}</StyledDice>;
}

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await getI18nProps({ locale })),
    },
  };
}

export default CatchError(Dice);
